import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import mitt from 'mitt'
const emitter = mitt()
import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import VueLazyLoad from 'vue3-lazyload'
import { iconsSet as icons } from '@/assets/icons'
import DocsCallout from '@/components/DocsCallout'
import DocsExample from '@/components/DocsExample'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import Toaster from "@meforma/vue-toaster";
import VueColor from '@ckpack/vue-color';
import i18n from '@/config/i18'
import VueApexCharts from "vue3-apexcharts";



const app = createApp(App)
app.use(VueApexCharts);
app.use(store)
app.use(i18n)
app.use(VueColor)
app.use(router)
app.use(CoreuiVue)
app.use(ElementPlus)
app.use(Toaster)
app.use(VueLazyLoad)
app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('DocsCallout', DocsCallout)
app.component('DocsExample', DocsExample)
app.config.globalProperties.emitter = emitter
app.mount('#app')
